export default "__VITE_ASSET__CzBTtpW2__"